export default __webpack_public_path__ + "static/cloud1-5e6e862b4dd5d9f5224fb58923a1ef6b.png";